import { computed } from 'mobx';
import { getAllOptions } from 'owa-options-store';
import * as Fuse from 'fuse.js';
import strings from 'owa-strings/owa-options-strings';
var searchModel = computed(function () {
    var searchTerms = getAllOptions().map(function (option) { return ({
        searchTerm: strings[option.searchTermsStringKey],
        option: option,
    }); });
    var maxLength = searchTerms.reduce(function (max, searchTerm) { return Math.max(max, searchTerm.searchTerm.length); }, 0);
    return new Fuse(searchTerms, {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: maxLength,
        maxPatternLength: 50,
        tokenize: true,
        keys: ['searchTerm'],
    });
});
export default (function () { return searchModel.get(); });
//# sourceMappingURL=searchModel.js.map